<ngx-spinner [fullScreen]="true">
  <!-- <img src="assets/img/Untitled-3.gif" style="height: 250px; width:0 250px" /> -->
</ngx-spinner>

<router-outlet></router-outlet>
